import { useEffect, useState } from 'react';

/**
 * Logo component that switches between dark and light mode logos
 * based on the current theme.
 */
export function Logo({ className = "h-16", alt = "HealthLink360" }) {
  const [isDark, setIsDark] = useState(false);

  useEffect(() => {
    // Check initial theme
    const checkTheme = () => {
      setIsDark(document.documentElement.classList.contains('dark'));
    };
    
    checkTheme();

    // Watch for theme changes using MutationObserver
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === 'class') {
          checkTheme();
        }
      });
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class']
    });

    return () => observer.disconnect();
  }, []);

  // Use dark logo for dark mode, light logo for light mode
  const logoSrc = isDark 
    ? '/logo-dark.svg'
    : '/logo-light.svg';

  return (
    <img
      src={logoSrc}
      alt={alt}
      className={className}
      data-testid="app-logo"
    />
  );
}

export default Logo;
